import logo from "./logo.svg";
import "./App.css";
// import { Router } from "react-router-dom";
import { Router } from "./Routing/Router";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      {" "}
      <Toaster position="top-center" />
      <Router />
    </>
  );
}

export default App;
